import React from 'react';
import { Link } from 'react-router-dom';

export default function PrivacyPage() {
  return (
    <div style={{ fontFamily: 'Arial, sans-serif', background: '#f5f5f5', minHeight: '100vh', margin: 0, padding: 0, color: '#333', lineHeight: 1.7 }}>
      <div style={{ maxWidth: 900, margin: '40px auto', background: '#fff', padding: 40, borderRadius: 12, boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}>

        <h1 style={{ textAlign: 'center', color: '#111', marginBottom: 10 }}>BellezBuy Privacy Policy</h1>
        <p style={{ textAlign: 'center', color: '#777', marginBottom: 30 }}><strong>Effective Date:</strong> May 26, 2026</p>

        <p>
          Welcome to BellezBuy. Your privacy is important to us. This Privacy Policy explains how BellezBuy collects, uses,
          stores, and protects your information when you use our mobile application and related services.
        </p>
        <p style={{ marginTop: 12 }}>
          By using BellezBuy, you agree to the practices described in this Privacy Policy.
        </p>

        <h2 style={{ marginTop: 35, color: '#222', borderBottom: '2px solid #eee', paddingBottom: 8 }}>1. Information We Collect</h2>

        <h3 style={{ marginTop: 16, color: '#333' }}>Personal Information</h3>
        <ul style={{ paddingLeft: 20 }}>
          <li style={{ marginBottom: 8 }}>Full name</li>
          <li style={{ marginBottom: 8 }}>Email address</li>
          <li style={{ marginBottom: 8 }}>Phone number</li>
          <li style={{ marginBottom: 8 }}>Shipping and billing address</li>
          <li style={{ marginBottom: 8 }}>Profile information</li>
        </ul>

        <h3 style={{ marginTop: 16, color: '#333' }}>Payment Information</h3>
        <p>
          Payments are processed securely through third-party payment providers. BellezBuy does not store your complete
          debit/credit card information on our servers.
        </p>

        <h3 style={{ marginTop: 16, color: '#333' }}>Device Information</h3>
        <ul style={{ paddingLeft: 20 }}>
          <li style={{ marginBottom: 8 }}>Device model</li>
          <li style={{ marginBottom: 8 }}>Operating system</li>
          <li style={{ marginBottom: 8 }}>App version</li>
          <li style={{ marginBottom: 8 }}>IP address</li>
          <li style={{ marginBottom: 8 }}>Mobile network information</li>
        </ul>

        <h3 style={{ marginTop: 16, color: '#333' }}>Usage Information</h3>
        <ul style={{ paddingLeft: 20 }}>
          <li style={{ marginBottom: 8 }}>Products viewed</li>
          <li style={{ marginBottom: 8 }}>Search history</li>
          <li style={{ marginBottom: 8 }}>Cart and wishlist activity</li>
          <li style={{ marginBottom: 8 }}>Order history</li>
          <li style={{ marginBottom: 8 }}>App interaction data</li>
        </ul>

        <h3 style={{ marginTop: 16, color: '#333' }}>Location Information</h3>
        <p>
          If enabled by the user, we may collect approximate location data to improve delivery and location-based services.
        </p>

        <h2 style={{ marginTop: 35, color: '#222', borderBottom: '2px solid #eee', paddingBottom: 8 }}>2. How We Use Your Information</h2>
        <ul style={{ paddingLeft: 20 }}>
          <li style={{ marginBottom: 8 }}>Create and manage your account</li>
          <li style={{ marginBottom: 8 }}>Process orders and payments</li>
          <li style={{ marginBottom: 8 }}>Deliver products and services</li>
          <li style={{ marginBottom: 8 }}>Provide customer support</li>
          <li style={{ marginBottom: 8 }}>Improve app functionality and user experience</li>
          <li style={{ marginBottom: 8 }}>Send order updates and notifications</li>
          <li style={{ marginBottom: 8 }}>Detect fraud and maintain security</li>
          <li style={{ marginBottom: 8 }}>Offer promotions, discounts, and personalized recommendations</li>
        </ul>

        <h2 style={{ marginTop: 35, color: '#222', borderBottom: '2px solid #eee', paddingBottom: 8 }}>3. Sharing of Information</h2>
        <p>We may share your information with:</p>
        <ul style={{ paddingLeft: 20, marginTop: 8 }}>
          <li style={{ marginBottom: 8 }}>Delivery and logistics partners</li>
          <li style={{ marginBottom: 8 }}>Payment gateway providers</li>
          <li style={{ marginBottom: 8 }}>Customer support providers</li>
          <li style={{ marginBottom: 8 }}>Analytics and marketing service providers</li>
          <li style={{ marginBottom: 8 }}>Legal authorities when required by law</li>
        </ul>
        <p style={{ marginTop: 8 }}>We do not sell your personal information to third parties.</p>

        <h2 style={{ marginTop: 35, color: '#222', borderBottom: '2px solid #eee', paddingBottom: 8 }}>4. Data Security</h2>
        <p>
          We use reasonable administrative, technical, and physical security measures to protect your information against
          unauthorized access, loss, misuse, or alteration.
        </p>
        <p style={{ marginTop: 8 }}>However, no method of electronic transmission or storage is completely secure.</p>

        <h2 style={{ marginTop: 35, color: '#222', borderBottom: '2px solid #eee', paddingBottom: 8 }}>5. User Rights</h2>
        <p>You may have the right to:</p>
        <ul style={{ paddingLeft: 20, marginTop: 8 }}>
          <li style={{ marginBottom: 8 }}>Access your personal information</li>
          <li style={{ marginBottom: 8 }}>Update or correct your information</li>
          <li style={{ marginBottom: 8 }}>Delete your account</li>
          <li style={{ marginBottom: 8 }}>Opt out of marketing communications</li>
        </ul>

        <h2 style={{ marginTop: 35, color: '#222', borderBottom: '2px solid #eee', paddingBottom: 8 }}>6. Cookies and Tracking Technologies</h2>
        <p>BellezBuy may use cookies and similar technologies to:</p>
        <ul style={{ paddingLeft: 20, marginTop: 8 }}>
          <li style={{ marginBottom: 8 }}>Improve app performance</li>
          <li style={{ marginBottom: 8 }}>Remember user preferences</li>
          <li style={{ marginBottom: 8 }}>Analyze app usage</li>
          <li style={{ marginBottom: 8 }}>Personalize content and offers</li>
        </ul>

        <h2 style={{ marginTop: 35, color: '#222', borderBottom: '2px solid #eee', paddingBottom: 8 }}>7. Third-Party Services</h2>
        <p>
          Our app may include third-party services such as payment gateways, analytics tools, and push notification services.
        </p>

        <h2 style={{ marginTop: 35, color: '#222', borderBottom: '2px solid #eee', paddingBottom: 8 }}>8. Children's Privacy</h2>
        <p>
          BellezBuy is not intended for children under the age of 13. We do not knowingly collect personal information from children.
        </p>

        <h2 style={{ marginTop: 35, color: '#222', borderBottom: '2px solid #eee', paddingBottom: 8 }}>9. Changes to This Privacy Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. Updated versions will be posted within the app or on our official website.
        </p>


        <h2 style={{ marginTop: 35, color: '#222', borderBottom: '2px solid #eee', paddingBottom: 8 }}>Consent</h2>
        <p>
          By using BellezBuy, you consent to the collection and use of information in accordance with this Privacy Policy.
        </p>

        <div style={{ marginTop: 40, paddingTop: 20, borderTop: '1px solid #eee', display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10 }}>
          <p style={{ fontSize: 12, color: '#aaa' }}>© 2026 BellezBuy. All rights reserved.</p>
          <Link to="/login" style={{ fontSize: 12, color: '#4f46e5', textDecoration: 'none' }}>Back to Login</Link>
        </div>

      </div>
    </div>
  );
}
